import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import UserAvatar from 'components/UserAvatar';

import { useUser } from 'providers/UserProvider';

const TextEditorUserAvatar = ({ className }) => {
  const { isLoggedIn, LoggedInUser } = useUser();

  if (!isLoggedIn) {
    return (
      <UserAvatar
        className={className}
        description="Usuário deslogado"
        size="size5"
        userLevel={0}
      />
    );
  }

  return (
    <UserAvatar
      className={twJoin('h-fit', className)}
      size="size5"
      userLevel={LoggedInUser.userLevel}
      userName={LoggedInUser.userName}
      userPhoto={LoggedInUser.userPhoto}
      userTypeName={LoggedInUser.userTypeName}
      userUsername={LoggedInUser.userUsername}
      asLink
    />
  );
};

TextEditorUserAvatar.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default TextEditorUserAvatar;
